var _g, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconSettings = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 16,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.091 2.024a1.223 1.223 0 0 0 1.818 0l.59-.649a1.224 1.224 0 0 1 2.132.883l-.044.875a1.223 1.223 0 0 0 1.282 1.284l.875-.045a1.225 1.225 0 0 1 .88 2.132l-.65.587a1.225 1.225 0 0 0 0 1.818l.65.588a1.224 1.224 0 0 1-.882 2.131l-.875-.044a1.223 1.223 0 0 0-1.285 1.285l.044.875a1.224 1.224 0 0 1-2.126.881l-.588-.65a1.225 1.225 0 0 0-1.818 0l-.59.65a1.224 1.224 0 0 1-2.129-.88l.045-.875a1.224 1.224 0 0 0-1.285-1.285l-.875.044A1.223 1.223 0 0 1 1.375 9.5l.65-.588a1.225 1.225 0 0 0 0-1.818l-.65-.59a1.224 1.224 0 0 1 .88-2.129l.876.044a1.224 1.224 0 0 0 1.286-1.287l-.042-.876a1.224 1.224 0 0 1 2.129-.881z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.187 8a2.812 2.812 0 1 0 5.625 0 2.812 2.812 0 0 0-5.625 0"
  }))));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 16,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: fill,
    stroke: stroke,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.091 2.024a1.223 1.223 0 0 0 1.818 0l.59-.649a1.224 1.224 0 0 1 2.132.883l-.044.875a1.223 1.223 0 0 0 1.282 1.284l.875-.045a1.225 1.225 0 0 1 .88 2.132l-.65.587a1.225 1.225 0 0 0 0 1.818l.65.588a1.224 1.224 0 0 1-.882 2.131l-.875-.044a1.223 1.223 0 0 0-1.285 1.285l.044.875a1.224 1.224 0 0 1-2.126.881l-.588-.65a1.225 1.225 0 0 0-1.818 0l-.59.65a1.224 1.224 0 0 1-2.129-.88l.045-.875a1.224 1.224 0 0 0-1.285-1.285l-.875.044A1.223 1.223 0 0 1 1.375 9.5l.65-.588a1.225 1.225 0 0 0 0-1.818l-.65-.59a1.224 1.224 0 0 1 .88-2.129l.876.044a1.224 1.224 0 0 0 1.286-1.287l-.042-.876a1.224 1.224 0 0 1 2.129-.881z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.187 8a2.812 2.812 0 1 0 5.625 0 2.812 2.812 0 0 0-5.625 0"
  }))));
});
export default SvgIconSettings;
export const raw = __webpack_public_path__ + "static/media/IconSettings.c826f2fab6826bcdfd218cc60d28caa0.svg";